import { render, staticRenderFns } from "./BreakProject.vue?vue&type=template&id=0c1f4000&scoped=true"
import script from "./BreakProject.vue?vue&type=script&lang=js"
export * from "./BreakProject.vue?vue&type=script&lang=js"
import style0 from "./BreakProject.vue?vue&type=style&index=0&id=0c1f4000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f4000",
  null
  
)

export default component.exports